import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as JoyBuddy } from '../../../../../assets/icons/buddy-joy.svg';
import { BreadcrumbItemProps } from '../../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import GenericPageNE from '../../../../../shared/components/GenericPageNE/GenericPageNE';
import { REWARDS_HISTORY_ROUTE } from '../../../../../shared/constants/auth';
import { CLICK_ACTION, GO_TO_ORDER_HISTORY, SEND_MORE_POINTS } from '../../../../../shared/constants/tagManager';
import tagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_POINTS_BY_FILE } from '../../../../../shared/translations/rewards';

interface PointsByFileSuccessProps {
  breadcrumbs: BreadcrumbItemProps[];
  orderNumber?: string;
  resetPage: () => void;
}

const PointsByFileSuccess = ({ breadcrumbs, orderNumber, resetPage }: PointsByFileSuccessProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goToHistory = () => {
    tagManagerService.pushEvent(CLICK_ACTION, GO_TO_ORDER_HISTORY);
    navigate(REWARDS_HISTORY_ROUTE);
  };

  const onSendMorePoints = () => {
    resetPage();
    tagManagerService.pushEvent(CLICK_ACTION, SEND_MORE_POINTS);
  };

  return (
    <GenericPageNE
      breadcrumbs={breadcrumbs}
      ImageComponent={JoyBuddy}
      title={{ i18nKey: TRANSLATION_POINTS_BY_FILE.success.title, components: { 1: <br /> } }}
      description={t(TRANSLATION_POINTS_BY_FILE.success.description)}
      tag={{ text: t(TRANSLATION_POINTS_BY_FILE.success.tag, { order: orderNumber }), type: 'neutral', curved: true }}
      primaryButton={{
        text: t(TRANSLATION_POINTS_BY_FILE.success.history),
        action: goToHistory
      }}
      secondaryButton={{
        text: t(TRANSLATION_POINTS_BY_FILE.success.sendMorePoints),
        action: onSendMorePoints
      }}
    />
  );
};

export default PointsByFileSuccess;
